export default {
  addOns: 'Estensioni',
  availability: 'Disponibilità',
  availabilityDaySelector: 'Selettore data di disponibilità',
  unavailable: 'Non disponibile',
  person: 'persona',
  people: 'persone',
  reserveNow: 'Prenota ora',
  selectTime: "Seleziona l'orario",
  select: 'Seleziona',
  reserve: 'Prenotare',
  time: 'Orario',
  tier: 'Livello',
  questions: 'Domande',
  addToCart: 'Aggiungi al carrello',
  checkout: 'Cassa',
  total: 'Totale',
  whatsIncluded: 'Cosa è incluso',
  showMore: 'Mostra di più',
  showLess: 'Mostra meno',
  session: 'Sessione',
  viewDetails: 'Visualizza dettagli',
  findAvailability: 'Trova disponibilità',
  loading: 'Caricamento',
  capacity: 'Capacità',
  noAvailableSessionsOnThisDate: 'Nessuna sessione disponibile in questa data',
  noGroupAvailableOnThisDateAndTime:
    'Nessun {{groupTitle}} disponibile in questa data e orario',
  noCollectionFound: 'Nessuna collezione trovata!',
  noResourceGroupFound: 'Nessun gruppo di risorse trovato!',
  noData: 'Nessun dato!',
  continue: 'Continua',
  night: 'notte',
  nights: 'notti',
  noAvailableSessionsForSelectedDates:
    'Alcune date nella tua selezione non hanno sessioni disponibili. Si prega di selezionare date diverse.',
  from: 'da',
  dateRangeSelector: 'Selettore intervallo date',
  priceTierRadioGroup: 'Selettore livello prezzo',
  startTime: 'Ora di inizio',
  duration: 'Durata',
  lengthOfStay: 'Durata del soggiorno',
  startDate: 'Data di inizio',
  endDate: 'Data di fine',
  selectDates: 'Seleziona le date',
  more: 'Altro',
  selectStartTime: 'Scegli un orario di inizio',
  endTime: 'Ora di fine',
  selectEndTime: 'Scegli un orario di fine',
  morning: 'Mattina',
  afternoon: 'Pomeriggio',
  save: 'Salva',
  selectDuration: 'Scegli una durata',
  forLength: 'per {{length}}',
  moreDates: 'altri {{count}}',
  addDate: 'Aggiungi data',
  start: 'Inizio',
  end: 'Fine',
  pickupFrom: 'Ritiro dalle',
  returnBy: 'Riconsegna entro le',
  day: 'giorno',
  days: 'giorni',
  hour: 'ora',
  hours: 'ore',
};
